import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';
import { CompetitionFileRequest, ContentType } from '~/apis/ssf';

export function useUploadCompetitionFileMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (data: CompetitionFileRequest) => {
      return await SSF.api.competitionFilesCreate(data, {
        type: ContentType.FormData,
      });
    },
    retry: false,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useDeleteCompetitionFileMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.competitionFilesDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}
